<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedSchools"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolID-->
				<th>
					<p-columnFilter type="text" field="SchoolID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolNumber-->
				<th>
					<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolName-->
				<th>
					<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolID">School ID<p-sortIcon field="SchoolID"></p-sortIcon></th>
				<th pSortableColumn="SchoolNumber">School Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				<th pSortableColumn="SchoolName">School Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School">
				<td>
					<p-tableCheckbox [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
				</td>
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ School[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
